import {Pipe, PipeTransform} from '@angular/core';
import {formatCurrency} from "@angular/common";
import {isNullOrUndefined, isValidNumber} from "../utils";

@Pipe({
    name: 'etsPkgPrice'
})

export class PackageComparisonPricePipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        if (value === Number.NEGATIVE_INFINITY) {
            return 'N/A';
        }

        if (!isValidNumber(value)) {
            return null;
        }

        let digitsInfo = '1.2-2';
        let currencyCode = 'USD';

        if (args.length > 0) {
            currencyCode = args[0];
            if (args.length > 1) {
                digitsInfo = args[1];
            }
        }

        const result = formatCurrency(value, 'en-US', '$', currencyCode, digitsInfo);

        return result;
    }
}